/**
 * The Spaceti glyph, inline.
 *
 * Inlined rather than served as a file so the brand mark paints in the
 * first frame — it sits at the top of an auth screen, where a late-loading
 * logo reads as a broken page. Paths are byte-identical to Passport's
 * `passport_logo` helper so the two apps never drift apart visually; only
 * the default size differs, since here the mark stands without a wordmark
 * beside it and needs the extra couple of pixels to hold the row.
 */
export function SpacetiMark({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 60 60" aria-hidden="true">
      <path
        fill="#262E42"
        d="M58.563,15.797c-0.861,0.433-1.83,0.683-2.859,0.683c-3.52,0-6.374-2.854-6.374-6.374 c0-1.344,0.418-2.59,1.129-3.618C45.207,4.059,38.137,3.702,30.556,3.94C15.159,4.424,0.71,8.724,0.718,21.445 c0.009,13.538,13.702,35.771,33.52,34.636C48.744,55.25,59.92,36.383,59.449,21.632C59.379,19.431,59.07,17.501,58.563,15.797z"
      />
      <circle fill="#00A4B3" cx="55.794" cy="10.106" r="3.792" />
      <path
        fill="#FFFFFF"
        d="M27.276,29.984c0,0-0.519,3.154,0.366,7.029c1.068,4.678,5.162,8.556,5.162,8.556 c1.361-13.835,5.034-22.067,11.577-29.29C22.936,20.054,17.36,32.245,17.36,32.245s2.45-1.322,5.133-1.911 C24.423,29.91,26.6,29.966,27.276,29.984"
      />
      <path
        fill="#00A4B3"
        d="M43.881,16.409c0.169-0.041,0.258-0.061,0.258-0.061c-21.444,3.776-26.78,15.897-26.78,15.897 s2.646-1.396,4.891-1.842c1.997-0.396,4.086-0.349,4.746-0.32c-0.107,1.027-0.304,3.9,0.404,6.999 c1.069,4.682,4.757,7.904,5.403,8.487c-0.586-0.763-3.581-4.996-4.165-9.483c-0.473-3.635,0.008-7.077,0.008-7.077 s-3.564-0.94-8.108,0.621C26.796,20.831,41.737,16.93,43.881,16.409z"
      />
    </svg>
  )
}
